//NOTE: This component is exactly similar to the day component but has been created to allow the calendar app to be upgrade proof

import * as React from 'react';
import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { connect } from 'react-redux';

import GridNextPrevMonthDayView from 'grid-next-prev-month-day.view';
import { ICalendarAppState } from '../../redux-state';


interface IGridDayExternalProps {
    day: IDay<IEvent>;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type GridNextPrevMonthDayProps = IGridDayExternalProps & StateToProps;

export const GridNextPrevMonthDayBase: React.StatelessComponent<GridNextPrevMonthDayProps> = props => {
    return (
        <GridNextPrevMonthDayView {...props} />
        )
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(GridNextPrevMonthDayBase);